:root,
.uic-theme-responsive {
  --uxc-app-header-height: 52px;
  --uxc-app-header-expandables-y-offset: 56px;
  --uxc-app-header-expandables-min-width: 300px;
  --uxc-app-header-z-index: 400;
  --uxc-app-header-bg-color: var(--uic-color-blue5);
  --uxc-app-header-separator-color: var(--uic-color-white);
  --uxc-app-header-launcher-width: 68px;
}

@media only screen and (min-width: 1024px) {
  .uic-theme-responsive {
    --uxc-app-header-height: 68px;
    --uxc-app-header-expandables-y-offset: 72px;
    --uxc-app-header-launcher-width: 85px;
  }
}
:root,
.uic-theme-responsive {
  --uxc-app-toast-notifications-z-index: 350;
}

.uxc-app-sidebar-notifications {
  width: 100%;
  position: relative;
}
.uxc-app-sidebar-notifications__inner {
  display: none;
}
.uic-sidebar--opening .uxc-app-sidebar-notifications__inner, .uic-sidebar--opened .uxc-app-sidebar-notifications__inner {
  display: block;
}
.uxc-app-sidebar-notifications .uic-sidebar {
  width: var(--uxc-app-header-expandables-min-width);
  color: var(--uic-color-black);
  background: var(--uic-color-white);
  box-shadow: var(--uic-flyout-shadow);
  transition: none;
}
.uxc-app-sidebar-notifications .uic-sidebar--align-header {
  top: var(--uxc-app-header-expandables-y-offset);
}
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--opened, .uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--opening, .uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--closed, .uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--closing,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--opened,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--opening,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--closed,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--closing {
  transform: none;
  transition: none;
}
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-left.uic-sidebar--closing,
.uxc-app-sidebar-notifications .uic-sidebar.uic-sidebar--side-right.uic-sidebar--closing {
  display: none;
}